import config from "../../config";

const apiDxEndpoint = config.apiDxEndpoint;

export default apiDxEndpoint;
